import { EventEmitter } from 'events';

class Sequence extends EventEmitter {

	constructor(channel, number) {
		super();
		this.empty = true;
		this.name = "";
		this.bars = 1;
		this.beats = [];
		this._createBeats();
		this.selectedBar = 1;
		this.channel = channel;
		this.number = number;

		this.selected = false;

		this.playing = false;
		this.queued = false;
		this.currentPlayingBeat = 0;
	}

	isPlaying() {
		return this.playing;
	}

	select() {
		this.selected = true;
	}

	deselect() {
		this.selected = false;
	}

	queue() {
		if(this.playing) return;
		this.queued = true;
		this.currentPlayingBeat = 0;
		this.emit('SEQUENCE_QUEUED', { channel: this.channel, sequence: this.number });
	}

	unqueue() {
		this.emit('SEQUENCE_UNQUEUED', { channel: this.channel, sequence: this.number });
		this.queued = false;
	}

	stop() {
		this.playing = false;
		this.currentPlayingBeat = 0;
	}

	getNextNotes() {
		if(this.queued) this.queued = false;
		if(!this.playing) {
			this.playing = true;
			this.emit('SEQUENCE_PLAYING', { channel: this.channel, sequence: this.number });
		}

		var l = this.beats.length;
		var notes = this.beats[this.currentPlayingBeat % l];
		this.currentPlayingBeat++
		if(this.currentPlayingBeat >= l) {
			this.currentPlayingBeat = 0;
			this.emit('SEQUENCE_FINISHED', { channel: this.channel, sequence: this.number });
		}
		return notes;
	}

	setNumberOfBars(bars) {
		this.bars = bars;
		if(this.selectedBar > this.bars) this.selectedBar = this.bars;
		this._createBeats();
		this.notEmpty();
	}

	_createBeats() {
		var size = this.bars * 16;
		var length = this.beats.length;
		if(length == size) return;
		if(length < size) {
			for (var i = length; i < size; i++) {
				this.beats.push([]);
			}
		} else {
			this.beats.splice(size, length - size);
		}
	}

	getBeatsInBar(bar) {
		return this.beats.slice((bar-1)*16, bar*16);
	}

	getSelectedBar() {
		return this.getBeatsInBar(this.selectedBar);
	}

	setSelectedBar(bar) {
		this.selectedBar = bar;
	}

	setName(name) {
		this.name = name;
		this.notEmpty();
	}

	notEmpty() {
		this.empty = false;
		if(this.name == "") {
			this.name = "Sequence " + (this.number+1);
		}
	}

	toggleNote(bar, beat, note) {
		var notes = this.beats[((bar-1)*16)+beat];
		var index = notes.indexOf(note);

		if(index === -1) {
			notes.push(note);
		} else {
			notes.splice(index, 1);
		}
		this.notEmpty();
	}

	makeEmpty() {
		this.empty = true;
		this.name = "";
		this.bars = 1;
		this.beats = [];
		this._createBeats();
		this.selectedBar = 1;

		this.selected = false;

		this.playing = false;
		this.queued = false;

		this.currentPlayingBeat = 0;
	}

	rehydrate(state) {
		if(typeof state.name !== "undefined" && state.name !== "") {
			this.name = state.name;
			this.bars = state.bars;
			this.beats = state.beats;
			this.empty = false;
			this.selectedBar = state.selectedBar;
		} else if(typeof this.name !== "undefined" && this.name !== "") {
			this.makeEmpty();
		}
		this.playing = false;
		this.queued = false;
	}

	dehydrate() {
		if(this.empty) {
			return {};
		} else {
			return {
				name: this.name,
				bars: this.bars,
				beats: this.beats,
				selectedBar: this.selectedBar
			};
		}
	}
}

export default Sequence;
